import React, { useEffect, useState } from 'react';
import { CONSENT_RESET_EVENT, getConsent, setConsent } from '../utils/analytics';

/** Asks before any advertising cookie is set; Accept grants storage to the Google tag (Consent Mode). */
const CookieBanner: React.FC = () => {
  const [open, setOpen] = useState(() => getConsent() === null);

  useEffect(() => {
    const reopen = () => setOpen(true);
    window.addEventListener(CONSENT_RESET_EVENT, reopen);
    return () => window.removeEventListener(CONSENT_RESET_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = (value: 'granted' | 'denied') => {
    setConsent(value);
    setOpen(false);
  };

  const button: React.CSSProperties = {
    border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 600, fontSize: 14, cursor: 'pointer',
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      style={{
        position: 'fixed', left: 16, right: 16, bottom: 16, zIndex: 10000, maxWidth: 640, margin: '0 auto',
        background: '#1f1f3a', color: '#fff', borderRadius: 12, padding: '16px 20px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)', display: 'flex', flexWrap: 'wrap', gap: 12,
        alignItems: 'center', justifyContent: 'space-between', fontSize: 14, lineHeight: 1.5,
      }}
    >
      <span style={{ flex: '1 1 320px' }}>
        We'd like to use Google Ads cookies to see which ads bring people to QA Master. No cookies are set unless you accept.
      </span>
      <span style={{ display: 'flex', gap: 8 }}>
        <button type="button" onClick={() => choose('denied')} style={{ ...button, background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.5)' }}>
          Reject
        </button>
        <button type="button" onClick={() => choose('granted')} style={{ ...button, background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff' }}>
          Accept
        </button>
      </span>
    </div>
  );
};

export default CookieBanner;
